import React from "react";
import { motion } from "framer-motion";
import { StarIcon } from "lucide-react";
import ImageSliderGrades from "./imagesslide";
import CommonImageSlider from "./comandata";
import { acadmicImages } from "./data";
import CallandRegisterComponent from "./Callbutton";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";


const videos = [
  {
    img: "https://img.youtube.com/vi/_PK08B0nbfQ/hqdefault.jpg",
    link: "https://www.youtube.com/watch?v=_PK08B0nbfQ",
  },
  {
    img: "https://img.youtube.com/vi/xQBSwXBm8BY/hqdefault.jpg",
    link: "https://www.youtube.com/watch?v=xQBSwXBm8BY",
  },
  {
    img: "https://img.youtube.com/vi/ygkvsNVHg5E/hqdefault.jpg",
    link: "https://www.youtube.com/watch?v=ygkvsNVHg5E",
  },
  {
    img: "https://img.youtube.com/vi/pKyOhvvYbO4/hqdefault.jpg",
    link: "https://www.youtube.com/watch?v=pKyOhvvYbO4",
  },
];

export default function AcademicPrograms() {
  return (<div className=" ms-0 me-0">
      <h2  className="text-xl text-center text-black font-extrabold mt-10 me-2 mb-4 ms-2">Where commitment meets IIT-JEE & NEET coaching, Rankridge results are born.</h2>
   
 <CommonImageSlider images={acadmicImages}/>

 <div className="mb-1 mt-2 me-2 ms-2">
<CallandRegisterComponent />
</div>
     <div className="bg-white   py-1">
      <h2 className="text-center m-5 text-green-900 text-4xl font-bold m-8">
        Rankridge Students Success Stories
      </h2>
      <div className="px-4 md:px-12">
        <Swiper
          spaceBetween={20}
          slidesPerView={1}
          breakpoints={{
            640: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
          loop={true}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          modules={[Autoplay]}
        >
          {videos.map((video, index) => (
            <SwiperSlide key={index}>
              <a href={video.link} target="_blank" rel="noopener noreferrer">
                <div className="relative bg-white rounded-xl overflow-hidden border-2 border-yellow-400 shadow-lg">
                  <img src={video.img} alt={`video-${index}`} className="w-full h-auto object-contain" />
                  <div className="absolute inset-0 bg-black bg-opacity-40 flex items-center justify-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="w-14 h-14 text-white"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path d="M8 5v14l11-7z" />
                    </svg>
                  </div>
                </div>
              </a>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>


    </div>
  );
}